
import Msg from 'vux/src/components/msg/index.vue'


export default {
components: {
Msg
},
data: () => ({
title: 'ĐÃ TIẾP NHẬN THẺ CÀO',
description: 'Đơn nạp đang được xử lý, nếu sau 10 phút vẫn không nhận được hãy liên hệ CSKH'
})
}



// WEBPACK FOOTER //
// ./src/components/Finished.vue